import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { CONSTANTS } from '@pk/powerkioskutils';

import { Product } from '../../shared/models';

export interface AuctionProduct {
	rfqSessionProductId?: FormControl<string>;
	type: FormControl<string>;
	term: FormControl<number>;
	greenPercentage: FormControl<number>;
	hidden?: FormControl<boolean>;
}

@Injectable({
	providedIn: 'root',
})
export class AuctionService {
	public getProductNote(stateId: string, products: FormArray<FormGroup<AuctionProduct>>, catalog: Product[]): string {
		const productIds = [CONSTANTS.products.energyOnly];
		if (products.value.some(p => p.type === CONSTANTS.products.fixedAllInElectric)) {
			productIds.push(...this.automaticFixedProductIds(stateId));
		}

		const productNotes = productIds
			.map(productId => catalog?.find(product => product.productId === productId)?.name)
			.filter((name): name is string => !!name)
			.map(name => `"${name}"`);

		return `${productNotes.join(', ')} product${productNotes.length > 1 ? 's' : ''} will be added automatically for each unique term + green percentage included in the new products getting added above if not already added.`;
	}

	private automaticFixedProductIds(stateId: string): string[] {
		switch (stateId) {
			case CONSTANTS.states.texas:
				return [CONSTANTS.products.fixedWithBasisPassThrough];
			case CONSTANTS.states.connecticut:
			case CONSTANTS.states.maine:
			case CONSTANTS.states.massachusetts:
			case CONSTANTS.states.newHampshire:
			case CONSTANTS.states.rhodeIsland:
			case CONSTANTS.states.vermont:
				return [CONSTANTS.products.fixedDasiAdjusment, CONSTANTS.products.fixedDasiIncluded, CONSTANTS.products.fixedDasiPassThrough];
			default:
				return [CONSTANTS.products.fixedWithAdjustment];
		}
	}
}
